var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrustWallet = function SvgTrustWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#DFE5EC",
    strokeWidth: 0.309,
    d: "M18.27 1.001H9.73A8.73 8.73 0 0 0 1 9.731v8.54a8.73 8.73 0 0 0 8.73 8.73h8.54a8.73 8.73 0 0 0 8.73-8.73v-8.54a8.73 8.73 0 0 0-8.73-8.73Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3375BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.874,
    d: "M14.08 6.968c2.438 2.036 5.234 1.91 6.033 1.91-.175 11.58-1.506 9.284-6.032 12.53-4.527-3.246-5.85-.95-6.024-12.53.79 0 3.586.126 6.024-1.91"
  })));
};
export { SvgTrustWallet as ReactComponent };